// removed by extract-text-webpack-plugin
module.exports = {"resultcardContainer":"ofkRvK-1nncIhm1U9Xsm-","marketContainer":"_17fsZLkzYz_YYye6redLDM","titleContainer":"_23h_wbazRlmukWPyGkcvT","topBar":"RLdPmjmkYooIHagz74UQi","container":"JlVEbDHP8lgUaMXMW0Lyp","innerContainer":"_3FxzhijW3jmflsfxWPReZu","titleTableWrapper":"w50E267C1DE9B3-Dg4S6f","title":"_2XO7A5pxkqZSs5R4hZ2qX4","odd":"_1XRHetGah63cic1KsdY62l","marketTitle":"_3-7mjPwmoPoZGMX8Dv4xTS","buttonStyle":"_1iSVPNZcRzWnbAPJFyHtjl","imageLoader":"_2jMYTxipG_pE5_hWiBXSSK","footballIcon":"_2WQFFcU1FAZkHlOkd-bX_8"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/football/css/resultCard.css
// module id = 1013
// module chunks = 0